<template>
  <div class="mb-3 label-option">
    <div class="flex justify-between mb-2 h-8 " v-if="isShowAutocompleteToggle">
      <div>
        <div
          class="flex gap-2 justify-end align-middle h-full "
        >
          <aha-button
            v-aha-emit-action
            name="generate-answer"
            :size="'lg'"
            :variant="'primary'"
            class="mb-1"
            :disabled="isRegenerateDisabled || isLoadingAutocomplete"
            @click="refresh"
          >
            <aha-spinner :variant="'white'" size="xs" v-if="isLoadingAutocomplete" />
            <aha-icon v-else name="sparkles-white" viewBox="0  0 16  16 " />
            <span>
              {{ $i18nPresenter.t('Generate options') }}
            </span>
          </aha-button>
          <span
            class="title-table-presentation-tooltip result-layout-tooltip
            tooltip-on-hover grid place-items-center cursor-pointer"
            v-tooltip="{
              content :tooltipGenerateAnswer,
              delay : {show : 0 , hide : 600},
              html : true
            }"
          >
            <span
              class="tooltip-btn"
            />

            <i
              class="fas fa-question-circle"
            />
          </span>
        </div>
      </div>
    </div>
    <div v-if="autocompleteError && isShowAutocompleteToggle" class="mb-3">
      <aha-info-box :variant="'error'">
        {{ autocompleteError }}
      </aha-info-box>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { slideType as SlideType } from '@/constant/allSlideTypes'
import OpenAIUtils from '@/utils/open-ai/OpenAIUtils'

export default {
  data() {
    return {
      loadingApproveAll: false,
      loadingRefresh: false,
    }
  },
  computed: {
    ...mapGetters('aiGenerateSlideOptions', ['isLoadingAutocomplete', 'autocompleteError', 'isApprovalAllowed', 'autoCompleteSlideOption']),
    ...mapGetters('userSettings', ['isSlideOptionAutocompleteEnabled']),
    ...mapState({
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
    }),
    tooltipGenerateAnswer() {
      return this.$i18nPresenter.t('thirdPartyAIInfoMessage', {
        openAI: '<a href="https://openai.com/enterprise-privacy/" style="color:white;text-decoration: underline;"  target="_blank">OpenAI</a>',
        groq: '<a href="https://groq.com/privacy" style="color:white;text-decoration: underline;"  target="_blank"> Groq</a>',
      })
    },
    isRegenerateDisabled() {
      return !OpenAIUtils.shouldGenerateSlideOptions(this.slideActive.title)
    },
    isShowAutocompleteToggle() {
      const { type, slideType } = this.slideActive
      // apple for pick answer and pick image
      return type === SlideType.pickAnswer && (
        slideType === null || slideType === 'imageChoice'
      )
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    ...mapGetters(['getSlideActive', 'getSlideOptionsActive']),
    ...mapActions('userSettings', ['setIsSlideOptionAutocompleteEnabledAction']),
    ...mapActions('aiGenerateSlideOptions', ['generateSlideOptionsAction']),
    async refresh() {
      this.loadingRefresh = true
      await this.generateSlideOptionsAction(this.slideActive.title)
      this.loadingRefresh = false
    },
  },

}
</script>
<style lang="scss" scoped >
// override legacy code
.flex {
  display: flex!important;
}
.wrapper-smart-toggle{
  align-items: center;
  .question-icon{
    visibility: hidden;
    transition: visibility 0.3s;
  }
  &:hover{
    .question-icon{
      visibility: visible;
    }
  }
}
</style>
